export const GENERIC_ERROR_MESSAGE =
  "An error occurred, Please try again. If error persists, contact your system administrator.";

export const REQUIRED_FIELD_MESSAGE = "This field is required";
export const INVALID_PHONE_NUMBER_MESSAGE = "Enter a valid phone number";

/**
 * Module Workflow Definitions
 */
export const MODULE_WORKFLOWS = {
  SYSTEM_USERS: 12,
  HQ_MARRIAGES: 13,
  COUNTY_MARRIAGES: 14,
  HQ_DIVORCES: 15,
  COUNTY_DIVORCES: 16,
} as const;

export const MODULE_WORKFLOW_NAMES: Record<number, string> = {
  12: "System Users",
  13: "HQ Marriages",
  14: "County Marriages",
  15: "HQ Divorces",
  16: "County Divorces",
};
